"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClient = void 0;
const axios_1 = __importDefault(require("axios"));
const tsyringe_1 = require("tsyringe");
let HttpClient = class HttpClient {
    // #endregion Properties (2)
    // #region Constructors (1)
    constructor() {
        // #region Properties (2)
        this._dataCache = {};
        axios_1.default.interceptors.response.use(response => {
            return response;
        }, error => {
            throw error;
        });
    }
    // #endregion Constructors (1)
    // #region Public Methods (7)
    addDataLoading(value) {
        this._loadData = value;
    }
    get(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return axios_1.default(url, Object.assign({ method: 'get' }, config));
        });
    }
    loadData(href, config = { responseType: 'blob' }) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataKey = btoa(href);
            if (this._dataCache[dataKey])
                return yield this._dataCache[dataKey];
            this._dataCache[dataKey] = new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                if (this._loadData) {
                    const response = yield this._loadData(href, config);
                    resolve(response);
                }
                else {
                    const response = yield this.get(href, config);
                    resolve(response);
                }
            }));
            return yield this._dataCache[dataKey];
        });
    }
    patch(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return axios_1.default(url, Object.assign({ method: 'patch' }, config));
        });
    }
    post(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return axios_1.default(url, Object.assign({ method: 'post' }, config));
        });
    }
    put(url, config) {
        return __awaiter(this, void 0, void 0, function* () {
            return axios_1.default(url, Object.assign({ method: 'put' }, config));
        });
    }
    removeDataLoading() {
        this._loadData = undefined;
    }
};
HttpClient = __decorate([
    tsyringe_1.singleton(),
    __metadata("design:paramtypes", [])
], HttpClient);
exports.HttpClient = HttpClient;
//# sourceMappingURL=HttpClient.js.map